import React from 'react';
import { Icon } from 'antd';
import moment from 'moment';
import StyledSelect from './styled';

const { Option } = StyledSelect;

const getDateKeyValue = (rawDate) => ({
  friendlyDate: moment(rawDate).format('ddd Do MMM YY'),
  dateKey: moment(rawDate).format('YYYY-MM-DD'),
});

const addOptionsToChildren = (date, children) => {
  const { friendlyDate, dateKey } = getDateKeyValue(date);

  children.push(
    <Option key={dateKey} value={dateKey}>
      {friendlyDate}
    </Option>
  );
};

const createOptionsForGarageProposedDates = (values, generatedDates, children) => {
  /**
   * We need this in case a garage has proposed a date not covered by the date loop below. Else the
   * proposed date will appear as YYYY-MM-DD format while the generated ones are in a friendly format.
   */

  const datesWithoutOptions = values.filter((selectedDate) => !generatedDates.includes(selectedDate));
  return datesWithoutOptions.map((date) => addOptionsToChildren(date, children));
};

const isWeekday = (dateKey) => ![0, 6].includes(moment(dateKey).weekday());

const MultiSelectDatePicker = ({ onChange, value: selectedDates }) => {
  const children = [];
  const generatedDates = [];
  const currentDate = new Date();

  for (let i = 0; i < 40; i++) {
    const nextDate = new Date(currentDate);
    nextDate.setDate(currentDate.getDate() + i);
    const { dateKey } = getDateKeyValue(nextDate);
    if (isWeekday(dateKey)) {
      generatedDates.push(dateKey);
      addOptionsToChildren(nextDate, children);
    }
  }

  createOptionsForGarageProposedDates(selectedDates, generatedDates, children);

  return (
    <StyledSelect
      suffixIcon={<Icon type="calendar" />}
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="Please select multiple dates"
      defaultValue={[]}
      onChange={onChange}
      value={selectedDates}
      onClick={(e) => e?.stopPropagation()}
    >
      {children}
    </StyledSelect>
  );
};

export default MultiSelectDatePicker;
